import { render, staticRenderFns } from "./main.vue?vue&type=template&id=18c619f2"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18c619f2')) {
      api.createRecord('18c619f2', component.options)
    } else {
      api.reload('18c619f2', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=18c619f2", function () {
      api.rerender('18c619f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/component/main.vue"
export default component.exports